export function mobilePostMessage(message) {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
    else if (window.self !== window.top && window.top.postMessage) {
        window.top.postMessage(message, "*");
    }
}
